import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadUserFromLocalStorage } from '../../actions/user';
import { setStorage } from '../../helpers/storage';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';

export const Saml = ({ match, location, history }) => {
    const dispatch = useDispatch();

    const [guid, setGuid] = React.useState(null);
    const [redirect, setRedirect] = React.useState(null);
    const { user } = useSelector(state => state.user);

    React.useEffect(() => {
        setGuid(match.params.guid);
        const values = queryString.parse(location.search);
        setRedirect(values.redirect);
    }, []);

    React.useEffect(() => {
        if (guid) {
            setStorage('user', guid);
            dispatch(loadUserFromLocalStorage(history, guid, true));
        }
    }, [guid]);

    React.useEffect(() => {
        if (user?.id) {
            history.push(redirect || '/');
        }
    }, [user]);

    return (
        <div className="flex flex-center flex-column">
            <h3>Logging into Richardson Insights...</h3>
            <div>
                <i className="fa fa-spin fa-cog text-lg mr10" />
                Please Wait
            </div>
        </div>
    );
};

export default withRouter(Saml);
